// extracted by mini-css-extract-plugin
module.exports = {"body":"_57a4ab3","button":"_b7681f1"};